import { Link } from "react-router-dom";
import '../assets/styles/CombinedCoopReport.scss';
import testAutomationImage from '../assets/images/sdlc.png';
import combinedOfficeImage from '../assets/images/combined_loop.gif';
import projectManagementImage from '../assets/images/combinedInsuranceHistory.png'
import combinedInsuranceImage from '../assets/images/English_Combined-removebg-preview.png';
import goalOwnershipImage from '../assets/images/projectManagement.png';
import automationGoalImage from '../assets/images/webScraping.png';
import teamCollaborationImage from '../assets/images/combinedTeamWork.jpg';
import impactImage from '../assets/images/seleniumyum.png';


function CombinedCoopReport() {
    return(
        <div className="coop-report-container">
            <Link to="/" className="back-button">← Back to Portfolio</Link>
            
            <header className="report-header">
                <div className="company-logo">
                    <img src={combinedInsuranceImage} alt="Combined Insurance Logo" />
                </div>
                <h2>Work Term Report</h2>
                <h3>IT Project Manager & Test Automation Engineer</h3>
                <div className="report-details">
                    <div className="detail-item">
                        <span className="detail-label">Program</span>
                        <span className="detail-value">Bachelor of Computing, Honors Co-op Computer Science</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Company</span>
                        <span className="detail-value">Combined Insurance, a Chubb Company</span>
                    </div>
                    <div className="detail-item">
                        <span className="detail-label">Term</span>
                        <span className="detail-value">Summer 2025</span>
                    </div>
                </div>
            </header>

            <div className="report-content">
                <section className="report-section">
                    <h3>Introduction</h3>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                My first co-op work term took place at Combined Insurance, a Chubb Company, where I worked as an IT Project Manager and Test Automation Engineer. This unique dual role allowed me to bridge the gap between project management and technical implementation.
                            </p>
                            <p>
                                Prior to this work term, I had completed two internships at different startups focusing on test automation engineering during summer 2024 and winter 2025. However, I had never experienced IT Project Management tasks, which motivated me to seek a co-op opportunity that would expand my skill set into the world of IT Project Management.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={combinedOfficeImage} alt="Combined Insurance Office" />
                        </div>
                    </div>
                </section>

                <section className="report-section">
                    <h3>About the Employer</h3>
                    
                    <h4>Company History & Background</h4>
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <p>
                                Combined Insurance, a Chubb Company, was founded in 1922 by W. Clement Stone. The company operates as a subsidiary of global insurance giant Chubb, having been acquired in 2008 to diversify Chubb's product offerings, specifically in the accident and health markets.
                            </p>
                            <p>
                                Since this acquisition, Combined has significantly contributed to Chubb's overall growth while benefiting from Chubb's established technology infrastructure and prestigious reputation. Combined Insurance's head office is located in Chicago, IL, and first expanded into Canada in 1956 via its Markham office, where I worked this summer.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={projectManagementImage} alt="Combined Insurance History" />
                        </div>
                    </div>

                    <h4>Mission & Customer Focus</h4>
                    <div className="full-width-content">
                        <p>
                            Combined Insurance's main purpose is to provide supplemental insurance that offers financial protection to individuals and families when they experience unexpected health issues, such as accidents, illnesses, or hospitalizations.
                        </p>
                        <p>
                            Since beginning my work at Combined, I've learned first-hand the quality of service and sympathy that Combined offers to its clients. Operating in a field that deals with grieving clients in times of need is no easy feat, so upholding a high standard of customer service is of utmost importance to this company. Combined emphasizes providing seamless and stress-free cash payouts to policyholders, creating a positive impact during the recovery process for those who suffer incidents and their families.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Job Description</h3>
                    
                    <h4>IT Project Management Organization (IT PMO) Team</h4>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                During this co-op term, I was part of the IT Project Management Organizations (IT PMO) team. This team serves as the critical bridge between Combined Insurance Company America (CICA) and third-party IT vendors and contractors, ensuring seamless project delivery and technology integration.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={teamCollaborationImage} alt="Team Collaboration" />
                        </div>
                    </div>
                    
                    <div className="responsibilities-grid">
                        <h4>Key Responsibilities</h4>
                        <div className="responsibility-item">
                            <h5>Test Automation Engineering</h5>
                        </div>
                        <p>In my role, I engineered Python test bots that automated the UAT process for new insuretech products. These bots leveraged pandas to clean and validate test data from Excel spreadsheets and used Selenium and Pyppeteer to mimic human browser activity for application submission. To maintain reliability, I implemented daemon multithreading services that detected and resolved unexpected pop-ups or system interruptions during testing. I also created comprehensive technical documentation that outlined best practices, advanced debugging techniques, and multithreading approaches, ensuring the automation could be scaled and maintained effectively.</p>
                        
                        <div className="responsibility-item">
                            <h5>Excel Script Automation</h5>
                        </div>
                        <p>I also designed an automated service to generate Excel-based UAT test scripts. Using Python and pandas, the system applied cartesian product transformations to combine datasets, such as insured candidates, beneficiaries, and income levels into complete, ready-to-use test cases. This reduced the time needed to create scripts from 37.5 hours to 15 hours, a 60% improvement that enabled faster preparation and execution of insurance policy simulations.</p>
                    
                        
                        <div className="responsibility-item">
                            <h5>Proof of Concept Development</h5>
                        </div>
                        <p>Beyond test automation, I led proof of concept initiatives to explore how technology could address broader UAT and business challenges. This included designing the system architecture for iPadOS application testing and collaborating with claims leadership to explore machine learning and deep learning models for fraud detection. I evaluated a variety of techniques, from Random Forests and clustering methods to autoencoders and convolutional neural networks for document fraud detection. These explorations sparked company-wide discussions on leveraging AI-driven solutions to solve operational pain points and highlighted the potential of innovation within insurance processes.</p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Goals & Objectives</h3>
                    
                    <p className="goals-intro">
                        I established several goals for this work term, combining measurable technical objectives with more subjective professional development targets. Each goal was strategically developed to align with job tasks and maximize my learning experience during this four-month term.
                    </p>

                    <div className="goal-reflection">
                        <h4>Goal 1: Project Ownership & Leadership</h4>
                    </div>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To own a specific area of different projects the IT PMO oversaw and become a dependable player for my coworkers. This would provide me with greater responsibility and the ability to impact the organization while creating tangible value.
                            </p>
                            <p>
                                I developed this goal in relation to my job tasks, as the IT PMO team needed someone who could handle certain areas of work independently, allowing other team members to focus on their respective processes for different CICA projects. The skills I learned to achieve this goal include effective communication and the ability to find and exceed expectations set by my managers.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={goalOwnershipImage} alt="Project Ownership" />
                        </div>
                    </div>
                    
                    <div className="goal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            Towards the second half of my work term, I was given full responsibility for the UAT test automation of an upcoming insurance product. I successfully owned this area of the insurance product for my team, demonstrating reliability and technical competence. Going the extra mile helped develop trust with my team, proving I could independently manage critical project components.
                        </p>
                    </div>

                    <div className="goal-reflection">
                        <h4>Goal 2: Advanced Test Automation Engineering</h4>
                    </div>
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To play a bigger role in the test automation engineering work at Combined Insurance, particularly on projects that would lead to significant efficiency improvements and business impact.
                            </p>
                            <p>
                                I already had test automation experience from previous internships, so when I identified a gap for a test automation engineer with experience in Python scripts using Selenium, Pandas, and Pyppeteer, I took the initiative to fill this role. Test automation engineering requires advanced software engineering skills, including understanding browser developer tools, navigating the Document Object Model, XPath, and solving complex Selenium errors.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={automationGoalImage} alt="Test Automation Goal" />
                        </div>
                    </div>

                    <div className="goal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            I successfully developed test automation solutions using Python, Selenium, and Pandas for the UAT automation project. The only tool I didn't use was Pyppeteer, as the team decided Selenium had better developer support and stability compared to Pyppeteer, which is an unofficial Python port of the Node.js Puppeteer library.
                        </p>
                    </div>

                    <div className="goal-reflection">
                        <h4>Goal 3: IT Project Management Experience</h4>
                    </div>
                    <div className="content-with-image">
                        <div className="text-content">
                            <p>
                                <strong>Objective:</strong> To gain comprehensive exposure to IT Project Management methodologies, processes, and best practices in a corporate environment.
                            </p>
                            <p>
                                This goal was designed to complement my technical background with project management skills, preparing me for leadership roles in technology projects. I wanted to understand how projects are planned, executed, and delivered in a large corporate setting.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={testAutomationImage} alt="Project Management" />
                        </div>
                    </div>

                    <div className="agoal-reflection">
                        <h5>Reflection & Achievement</h5>
                        <p>
                            Through my role in the IT PMO team, I gained extensive experience in project management processes, vendor coordination, and cross-functional collaboration. This experience has renewed my interest in my Project Management minor as part of my undergraduate honors co-op computer science degree.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Impact & Results</h3>
                    
                    <div className="content-with-image reverse">
                        <div className="text-content">
                            <h4>Quantifiable Business Impact</h4>
                            <p>
                                My work on the automating the UAT application testing process led to an <strong>83% decrease in standard application keying time</strong>, transforming a 25-30 minute manual process into a 5-minute automated solution allowing the IT PMO team to identify issues much earlier in the UAT cycle. This acceleration improved coordination between stakeholders, minimized delays, and helped projects progress according to schedule.
                            </p>
                            
                            <h4>Technical Achievements</h4>
                            <p>
                                The test bot software I developed with Python, Selenium, Excel, and Pandas can read and clean candidate testing data from spreadsheets, then mimic human browser activity to automate the internet application process for new insurance products. This automation helps the PMO team identify testing errors earlier, allowing projects to move forward more efficiently.
                            </p>
                        </div>
                        <div className="image-content">
                            <img src={impactImage} alt="Business Impact" />
                        </div>
                    </div>
                </section>

                <section className="report-section">

                    <h3>Acknowledgements</h3>
                    <div className="full-width-content">
                        <p>
                            I would like to extend my gratitude to my team at Combined Insurance, particularly my manager, 
                            <strong> Pulkit Singh Parihar</strong>. Pulkit was instrumental in my development and growth 
                            throughout this work term, as he gave me a chance whenever an opportunity came up that aligned 
                            with my personal goals. His support and mentorship allowed me to become experienced in both 
                            test automation engineering as well as IT Project Management, which gave me the experience to 
                            qualify for future opportunities in work terms.
                        </p>
                        <p>
                            I'd also like to thank <strong>Ron Kumar</strong>, <strong>Raluca Temciuc</strong>, 
                              <strong> Andy Chen</strong>, and <strong>Pushpinder Singh Bhatia</strong>, as they were 
                            integral in supporting my work and mentoring me in IT Project Management and Test Automation 
                            Engineering.
                        </p>
                    </div>
                </section>

                <section className="report-section">
                    <h3>Conclusion</h3>
                    
                    <div className="full-width-content">
                        <h4>Exceeded Expectations</h4>
                        <p>
                            This work term exceeded my expectations in every way. I entered this experience thinking I would perform intern-level tasks in IT Project Management, but instead I developed high-impact test automation software and documentation, conducted third-party risk management for external vendors, created internal services for generating UAT test cases, and spearheaded Proof of Concept designs for iPadOS keying automations and fraud detection using machine learning algorithms.
                        </p>

                        <h4>Personal Growth & Learning</h4>
                        <p>
                            It feels rewarding to know that my work has a tangible impact on a larger cause, which contrasts significantly with traditional coursework. The biggest impact of this work term was my test automation engineering tasks for the user acceptance testing (UAT) of new insurance products.
                        </p>

                        <h4>Future Applications</h4>
                        <p>
                            My experience with Test Automation Engineering will directly influence my projects and future courses at the University of Guelph. The IT Project Management aspect has renewed my interest in my Project Management minor as part of my undergraduate honors co-op computer science degree. The support, mentorship, and skills I gained from these experiences will be integral for my success in future co-op terms and career opportunities.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default CombinedCoopReport;